import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function usePlans(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getPlans() {
    return privateFetch.get(`/v1/admin/plan${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['plans', { data }], getPlans, { enabled });
}

export default usePlans;
